export enum FeedbackQuestionIds {
  OVERALL_SATISFACTION_WITH_DESIGN_SERVICE = "overallSatisfactionWithDesignService",
  ISSUES_AND_CONCERNS_RESOLVED = "issuesAndConcernsResolved",
}
